// Central notification event registry — reusable across the whole app.
// Channels are future-ready: sms | whatsapp | email | push.

export const NOTIFICATION_EVENTS = {
    // Complaint events (live)
    complaint_registered: { label: 'Complaint Registered', domain: 'complaint' },
    complaint_doctor_review: { label: 'Doctor Review', domain: 'complaint' },
    complaint_waiting_customer: { label: 'Waiting on Customer', domain: 'complaint' },
    complaint_courier_escalation: { label: 'Courier Escalation', domain: 'complaint' },
    complaint_refund_pending: { label: 'Refund Pending', domain: 'complaint' },
    complaint_replacement_pending: { label: 'Replacement Pending', domain: 'complaint' },
    complaint_resolved: { label: 'Complaint Resolved', domain: 'complaint' },
    complaint_closed: { label: 'Complaint Closed', domain: 'complaint' },

    // Future order events (registered, senders added later)
    order_confirmed: { label: 'Order Confirmed', domain: 'order' },
    order_shipped: { label: 'Order Shipped', domain: 'order' },
    order_delivered: { label: 'Order Delivered', domain: 'order' },
    order_delayed: { label: 'Order Delayed', domain: 'order' },
    order_cancelled: { label: 'Order Cancelled', domain: 'order' },

    // Future payment events
    payment_received: { label: 'Payment Received', domain: 'payment' },
    refund_issued: { label: 'Refund Issued', domain: 'payment' },
    refund_pending: { label: 'Refund Pending', domain: 'payment' },

    // Future follow-up events
    followup_created: { label: 'Follow-up Created', domain: 'followup' },
    followup_due: { label: 'Follow-up Due', domain: 'followup' },
    followup_missed: { label: 'Follow-up Missed', domain: 'followup' },
};

export const CHANNELS = ['sms', 'whatsapp', 'email', 'push'];
